import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import { createArray } from '../../../utilities/arrayHelper';
import OneOfRadioButton from './OneOfRadioButton';
import { translatableShape } from '../../../types';
import RowContainerList from './RowContainerList';

export default class OneOfOptions extends Component {
  componentDidMount() {
    const { getOneOf, numCases, defaultOption } = this.props;
    if (defaultOption) {
      for (let i = 0; i < numCases; i += 1) {
        const optionChecked = getOneOf(i);
        if (optionChecked === undefined) {
          this.props.onRadioButtonChange(defaultOption.uuid, i);
        }
      }
    }
  }

  render() {
    const {
      options,
      startCase,
      numCases,
      onRadioButtonChange,
      getOneOf,
      disabled,
    } = this.props;
    return (
      <div>
        {
          options.map((option, _index) => (
            <RowContainerList
              key={option.uuid}
              option={option}
              startCase={startCase}
              index={_index}
            >
              {
                createArray(numCases).map((_, sampleIndex) => {
                  const key = `option-${option.uuid}-${startCase}-${sampleIndex}`;
                  return (
                    <Tooltip key={key} title={`[P${sampleIndex + 1}] ${option.text}`}>
                      <li
                        className="mr2 basis-100 w2 flex flex-wrap justify-center content-center"
                        style={{ flexBasis: '100%' }}
                      >
                        <OneOfRadioButton
                          onChange={({ deselectButton = false } = {}) => {
                            if (deselectButton) {
                              onRadioButtonChange(undefined, sampleIndex);
                            } else {
                              onRadioButtonChange(option.uuid, sampleIndex);
                            }
                          }}
                          value={option.uuid}
                          name={`${startCase}-${sampleIndex}-radio`}
                          checked={getOneOf(sampleIndex) === option.uuid}
                          disabled={disabled}
                        />
                      </li>
                    </Tooltip>
                  );
                })
              }
            </RowContainerList>
          ))
        }
      </div>
    );
  }
}

OneOfOptions.defaultProps = {
  options: [],
  startCase: undefined,
  defaultOption: undefined,
  disabled: false,
};

OneOfOptions.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string,
  })),
  startCase: PropTypes.number,
  onRadioButtonChange: PropTypes.func.isRequired,
  getOneOf: PropTypes.func.isRequired,
  numCases: PropTypes.number.isRequired,
  defaultOption: translatableShape,
  disabled: PropTypes.bool,
};
